import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import PageHeader from "../-components/PageHeader";
import LoadingPop from "components/popup/LoadingPop";
import NoticesForm, { NoticeFormProps } from "./NoticeForm";
import { RouteTypes, shortcut } from "hooks/utils/util";
import { useGetConsoleNoticeDetail } from "hooks/console/useGetConsoleNoticeDetail";
import { useDeleteConsoleNotice } from "hooks/console/useDeleteConsoleNotice";
import ConsoleHrozontalHeadTable from "../-components/ConsolehorizontalHeadTable";
import { enum_api_uri } from "hooks/utils/enum";
import speaker from "assets/common/support/notice_speaker.png";
import ConfirmDialog from "components/popup/ConfirmDialog";
import Seo from "components/Seo";

const initialForm = {
    category: "",
    name: "",
    subject: "",
    contents: "",
    // notice: 0,
    notice: 0,
    b_file: "",
    list_no: null,
};

export default function ConsoleNoticeDetail({ type }: { type: RouteTypes }) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const idx = params.idx;
    const page = location.state?.page ?? "1";
    const [editMode, setEditMode] = useState(false);
    const { data, isLoading } = useGetConsoleNoticeDetail({ category: type, list_no: idx ?? "" });
    const { mutate: deleteNotice } = useDeleteConsoleNotice(() => navigate(-1));
    const [form, setForm] = useState<NoticeFormProps>(initialForm);
    const { 공지사항상세 } = shortcut(type, idx);

    // console.log("page", page);
    // console.log("detail", data);

    useEffect(() => {
        if (data) {
            setForm(prev => ({
                ...prev,
                category: type,
                name: "관리자",
                subject: data.subject || "",
                contents: data.contents || "",
                notice: data.notice,
                b_file: data.b_file,
                list_no: idx ? Number(idx) : null,
            }));
        }
    }, [data]);

    const thead = [
        {
            title: "상단고정",
            key: "notice",
            content: (value: string) => (
                <div>{value ? <img src={speaker} alt="" /> : <span className="text-[14px] text-[#666666]">-</span>}</div>
            ),
        },
        { title: "제목", key: "subject" },
        { title: "작성일", key: "w_date" },
        {
            title: "첨부파일",
            key: "b_file",
            content: (value: string) => {
                if (value) {
                    return (
                        <div
                            className="hover:underline cursor-pointer"
                            onClick={() => {
                                const src = enum_api_uri.api_uri + "/upload/board/" + value;
                                window.open(src, "_blank", "noopener, noreferrer");
                            }}
                        >
                            {value}
                        </div>
                    );
                }
                return <div>파일 없음</div>;
            },
        },
        {
            title: "내용",
            key: "contents",
            content: (value: string) => <div className="py-3" dangerouslySetInnerHTML={{ __html: value }} />,
        },
    ];

    const handleDeleteNotice = () => {
        deleteNotice({ category: type, list_no: [Number(idx)] });
    };
    const updateNotice = () => setEditMode(true);

    if (!idx) return <div>잘못된 접근입니다.</div>;

    return (
        <>
            <Seo type="console" pageTitle="공지사항" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="사이트관리" title="공지사항상세" linkTo={공지사항상세} />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        {data ? (
                            <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px]">
                                {editMode ? (
                                    <>
                                        {isLoading ? (
                                            <LoadingPop />
                                        ) : (
                                            <NoticesForm type={type} form={form} setForm={setForm} setEditMode={setEditMode} update />
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <ConsoleHrozontalHeadTable thead={thead} tbody={data} />
                                        <div className="flex justify-center gap-x-[8px] mt-5">
                                            <button
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                onClick={updateNotice}
                                            >
                                                수정
                                            </button>

                                            <ConfirmDialog
                                                title="공지 삭제"
                                                trigger={open => (
                                                    <button
                                                        type="button"
                                                        onClick={open}
                                                        className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                    >
                                                        삭제
                                                    </button>
                                                )}
                                                handleConfirm={handleDeleteNotice}
                                            />

                                            <button
                                                onClick={() => (page ? navigate(`/${type}/manage/notices?page=${page}`) : navigate(-1))}
                                                className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]"
                                            >
                                                목록
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="bg-white rounded-[20px] flex flex-col gap-5 items-center justify-center py-[100px]">
                                <p>결과가 없습니다.</p>
                                <button onClick={() => navigate(-1)} className="rounded-[8px] border px-5 py-2">
                                    뒤로가기
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
